(function(){
  var root=document.documentElement;

  /* ===================================================================
     SABİT ÜST ALANI KÜÇÜLT (duyuru şeridi GİZLENMEZ)

     13 Ekim 2026 — HİSTEREZİS EKLENDİ. Üst menünün kaydırırken bir
     büyüyüp bir küçülmesinin (titreme) sebebi buydu:

     ESKİ HÂLİ tek eşik kullanıyordu — scrollY > 340 olunca sınıf
     ekleniyor, altına düşünce kaldırılıyordu. Sınıf eklenince
     th-r9b.css header dolgusunu 20+16px'den 4+0px'e, logoyu 30px'e
     çekiyor; yani sayfanın ÜSTÜNDEKİ akış yüksekliği ~50px azalıyor.
     Tarayıcının scroll anchoring özelliği ekranda görünen içeriği
     sabit tutmak için scrollY'yi aynı miktarda geri alıyor → scrollY
     tekrar 340'ın altına düşüyor → sınıf kalkıyor → header büyüyor →
     scrollY yeniden 340'ı geçiyor... Kapanmayan bir döngü.
     setInterval(onScroll, 400) de kullanıcı hiç kaydırmasa bile bu
     döngüyü saniyede 2,5 kez yeniden tetikliyordu.

     ÇÖZÜM — üç parça:
     1) İKİ AYRI EŞİK. Kompakta geçiş 340'ta, geri dönüş 200'de.
        140px'lik ölü bölge, ~50px'lik yükseklik değişiminden çok daha
        geniş; anchoring kaynaklı geri sıçrama eşiği aşamıyor.
     2) GEÇİŞ KİLİDİ. CSS geçişi 0,22s sürüyor; bitene kadar (350ms)
        yeni karar alınmıyor, böylece animasyon sırasında ölçüm yok.
     3) setInterval ve capture fazındaki ikinci dinleyici kaldırıldı;
        tek passive dinleyici + requestAnimationFrame kısması kaldı.
        Kaydırma başına en fazla bir düzen hesabı yapılıyor.
     =================================================================== */
  var ESIK_AC = 340;   /* bu değerin ÜSTÜNDE kompakt moda geç */
  var ESIK_KAPA = 200; /* bu değerin ALTINDA normal moda dön */
  var kompakt = false, kilitBitis = 0, beklemede = false;

  function uygula(){
    beklemede = false;
    if(Date.now() < kilitBitis){ return; }
    var y = window.scrollY || document.documentElement.scrollTop || 0;
    var yeni = kompakt ? (y > ESIK_KAPA) : (y > ESIK_AC);
    if(yeni === kompakt){ return; }
    kompakt = yeni;
    root.classList.toggle('th-r9-scrolled', kompakt);
    kilitBitis = Date.now() + 350;
  }
  function onScroll(){
    if(beklemede){ return; }
    beklemede = true;
    (window.requestAnimationFrame || window.setTimeout)(uygula, 16);
  }
  window.addEventListener('scroll', onScroll, {passive:true});
  window.addEventListener('resize', onScroll, {passive:true});
  onScroll();

  /* --- WhatsApp balıncığını 6 sn sonra gizle --- */
  setTimeout(function(){ root.classList.add('th-r9-wa'); }, 6000);

  /* --- Hero: güven satırı --- */
  function trust(){
    document.querySelectorAll('.thh-slide').forEach(function(sl){
      if(sl.querySelector('.th-r9-trust')){return;}
      var cta=sl.querySelector('.thh-cta'); if(!cta){return;}
      var p=document.createElement('p'); p.className='th-r9-trust';
      p.innerHTML='<span><b>1.519 TL’den başlayan fiyatlar</b></span><i>·</i><span>Ücretsiz kargo</span><i>·</i><span>14 gün içinde iade</span>';
      cta.parentNode.insertBefore(p, cta.nextSibling);
    });
  }

  /* ===================================================================
     DÖRT FASET BÖLÜMÜ — tek sekme çubuğu, bölümler yerinde kalır.

     02 Ekim 2026 — YENİDEN YAZILDI. Üç sağlamlık sorunu vardı:

     1) BÖLÜM REFERANSLARI SAKLANIYORDU. Tıklama işleyicisi sayfa
        yüklenirken yakalanan DOM düğümünü tutuyordu. Bölüm herhangi
        bir sebeple yeniden render edilirse (Shopify bölüm yenilemesi,
        bir uygulama) referans bayatlıyor: tıklama "hepsini gizle"yi
        canlı düğümlere uyguluyor ama "bunu göster"i artık sayfada
        olmayan düğüme uyguluyordu — sonuç: HIÇBİRİ açılmıyor.
        Artık her tıklamada bölüm selektörle yeniden bulunuyor.

     2) AÇILAN BÖLÜM BOŞ GÖRÜNEBİLİYORDU. Kartlar th-motion'ın
        `.th-rv` sınıfıyla opacity:0 başlıyor ve IntersectionObserver
        ile açılıyor. Gizliyken (display:none) gözlemlenen bir öğe
        görünür olunca her tarayıcıda güvenilir şekilde tetiklenmiyor.
        Artık bir sekme açılınca içindeki tüm canlandırma öğelerine
        `.in` doğrudan veriliyor — gözlemciye hiç güvenmiyoruz.

     3) HATA DURUMUNDA İÇERİK KAYBOLUYORDU. Mekanizma çökerse dört
        bölüm birden gizli kalıyordu. Artık iki emniyet var:
        · Sekme açıldıktan sonra bölümün yüksekliği ölçülüyor;
          anlamsız derecede kısaysa mekanizma iptal ediliyor.
        · 3 sn sonra hiçbir faset bölümü görünür değilse iptal.
        İptal = <html>'e `th-fas-iptal` sınıfı; th-r10.css gizlemeyi
        kaldırıp bölümleri alt alta açıyor. Yani en kötü ihtimalle
        sekmeler öncesi haline dönüyoruz, içerik asla kaybolmuyor.

     r33 (27 Eki 2026) — wake() artık görselleri `loading=eager`a
     ÇEVİRMİYOR. Sayfa açılır açılmaz ilk faset bölümü (Odaya göre,
     telefonda ~5.000 px aşağıda) için 20+ görsel iniyordu; PageSpeed
     toplam sayfa ağırlığının büyük kısmı buydu. display:none'dan
     çıkan tembel görseli tarayıcı zaten kendisi yükler.
     =================================================================== */
  var FAS=[['th_oda','Odaya göre'],['th_desen','Desene göre'],['th_tarz','Tarza göre'],['th_renk','Renge göre']];
  var RV='.th-rv,.thp-h,.thbt-h,.thd-h,.tht-tx,.thr2-h,.thk-h,.thy-h,.thg-h,.thbl-h,'+
         '.thp-c,.thbt-k,.thd-k,.thr2-k,.thk-k,.thy-k,.thg-k,.thbl-k';
  var iptal=false;

  function sec(key){ return document.querySelector('[id$="__'+key+'"]'); }

  function bail(){
    if(iptal){ return; }
    iptal=true;
    root.classList.add('th-fas-iptal');
    FAS.forEach(function(f){
      var el=sec(f[0]);
      if(el){ el.classList.remove('th-fas-hide'); wake(el); }
    });
  }

  function wake(el){
    if(!el){ return; }
    /* Canlandırmayı doğrudan aç — gözlemciyi bekleme. */
    el.querySelectorAll(RV).forEach(function(n){ n.classList.add('in'); });
    if(el.matches && el.matches(RV)){ el.classList.add('in'); }
    el.querySelectorAll('img').forEach(function(im){
      if(!im.getAttribute('src') && im.dataset && im.dataset.src){ im.src=im.dataset.src; }
    });
    window.dispatchEvent(new Event('scroll'));
    window.dispatchEvent(new Event('resize'));
  }

  function goster(key){
    if(iptal){ return; }
    var hedef=sec(key);
    if(!hedef){ bail(); return; }
    FAS.forEach(function(f){
      var el=sec(f[0]);
      if(el){ el.classList.toggle('th-fas-hide', f[0]!==key); }
    });
    wake(hedef);
    /* Emniyet: açılan bölüm gerçekten yer kapladı mı? */
    setTimeout(function(){
      if(iptal){ return; }
      var h=sec(key);
      if(!h || h.offsetHeight < 80){ bail(); }
    }, 120);
  }

  function faset(){
    if(iptal || document.querySelector('.th-fas-bar')){ return; }
    var varOlan=FAS.filter(function(f){ return sec(f[0]); });
    if(varOlan.length<2){ return; }

    var ilk=sec(varOlan[0][0]);
    var bar=document.createElement('section');
    bar.className='th-fas-bar';
    bar.innerHTML='<span class="th-fas__k">Ne arıyorsun?</span>'
                + '<h2 class="th-fas__h">Nasıl seçmek istersin?</h2>'
                + '<div class="th-fas__tabs" role="tablist"></div>';
    ilk.parentNode.insertBefore(bar, ilk);
    var tabs=bar.querySelector('.th-fas__tabs');

    varOlan.forEach(function(f, i){
      var el=sec(f[0]);
      el.classList.add('th-fas-sec');
      if(i>0){ el.classList.add('th-fas-hide'); }
      var b=document.createElement('button');
      b.type='button'; b.className='th-fas__tab'; b.textContent=f[1];
      b.setAttribute('role','tab');
      b.setAttribute('data-fas', f[0]);
      b.setAttribute('aria-selected', i===0?'true':'false');
      tabs.appendChild(b);
    });

    /* Tek dinleyici, olay delegasyonu — düğüm referansı saklanmıyor. */
    tabs.addEventListener('click', function(ev){
      var b=ev.target.closest ? ev.target.closest('.th-fas__tab') : null;
      if(!b){ return; }
      tabs.querySelectorAll('.th-fas__tab').forEach(function(x){
        x.setAttribute('aria-selected', x===b ? 'true' : 'false');
      });
      goster(b.getAttribute('data-fas'));
    });

    wake(ilk);
  }

  function init(){ trust(); faset(); }
  if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded', init); } else { init(); }
  setTimeout(init, 1000);

  /* Son emniyet: 3 sn sonra hiçbir faset bölümü açık değilse iptal et. */
  setTimeout(function(){
    if(iptal){ return; }
    if(!document.querySelector('.th-fas-bar')){ return; }
    var acik=null;
    FAS.forEach(function(f){
      var el=sec(f[0]);
      if(el && !el.classList.contains('th-fas-hide')){ acik=el; }
    });
    if(!acik || acik.offsetHeight < 80){ bail(); } else { wake(acik); }
  }, 3000);
})();
